import './vendor/02_modernizr.min.js'
import Headroom from './vendor/03_headroom.min.js'
import './vendor/04_lazysizes.min.js'
import Instafeed from './vendor/06_instafeed.min.js'
import './vendor/08_cssua.min.js'

const Revel = {

  init() {

    this._cache();
    this._events();
    this._initHeroVideo();
    this._initHeadroom();
    // this._initInstagram();
    this._heroAnimation();
    this._annotateBlankLinks();
    this._repairNegativeTabIndexes();

    if ($('.js-map').length) {
      this._initMap();
    }

  }, // init()

  _cache() {

    this.$doc = $(document);
    this.$win = $(window);
    this.$html = $('html');
    this.$body = $('body');
    this.$mainWrap = $('main');
    this.$header = $('.js-header');
    this.$mainNav = $('.js-nav');
    this.$hamburger = $('.js-hamburger');
    this.$heroVideoLarge = document.getElementById('hero__video-large');
    this.$heroVideoSmall = document.getElementById('hero__video-small');
    this.$heroControls = $('.hero__controls');
    this.$heroAudioControl = $('.video--ctrl-audio');
    this.$heroPlaybackControl = $('.video--ctrl-playback');
    this.$heroVideo = $('.hero--video');
    this.mapMarketingConsent = false;
    this.mapInitialized = false;
    this.mapInitializationPending = false;
    this.mapWaitTimer = null;
    this.googleMap = null;
    this.googleMapMarker = null;

  }, // _cache()

  _events() {

    this.$html.on('click', '.js-hamburger', this._showMobileNav.bind(this));
    this.$html.on('click', '.js-scroll-to a', this._scrollToSection.bind(this));
    this.$html.on('click', '.js-scroll-top', this._scrollToTop.bind(this));
    this.$html.on('click', '.hero--video .hero__content', this._playHeroVideo.bind(this));
    this.$html.on('click', '.video--ctrl-audio', this._muteHeroVideo.bind(this));
    this.$html.on('click', '.video--ctrl-playback', this._pauseHeroVideo.bind(this));
    this.$html.on('click', '.video--ctrl-fullscr', this._fullscreenHeroVideo.bind(this));
    this.$html.on('click', '.video--ctrl-fullscr-exit', this._exitFullscreenHeroVideo.bind(this));
    this.$html.on('click', '.contact__locations__box .internal__editor a', this._showContactMapAddress.bind(this))
    document.addEventListener('cmplz_fire_categories', this._handleConsentCategories.bind(this));
    this.$doc.on('sbi_after_feed sbi_after_images_loaded', this._repairNegativeTabIndexes.bind(this));
    this.$mainNav.on('focusin', 'a', this._ensureMobileNavVisibleForFocus.bind(this));
    if (this.$heroVideoLarge) {
      this._syncHeroVideoControls()
      this.$heroVideoLarge.addEventListener('ended', this._resetHeroVideo.bind(this));
    }
  }, // _events()

  _initHeroVideo() {
    if (!this.$heroVideoLarge && !this.$heroVideoSmall) return

    this.activeHeroVideo = null
    this.$heroVideo
      .removeClass('is--large-video is--mobile-video')
      .addClass('is--small-video')
    this.$heroControls.removeClass('is--unmuted is--playing').addClass('is--muted is--paused')
    this._syncHeroVideoControls()
  },

  _isLargeHeroViewport() {
    return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || document.body.offsetWidth) >= 700
  },

  _getHeroVideoForPlayback() {
    if (!this._isLargeHeroViewport() && this.$heroVideoSmall) {
      return this.$heroVideoSmall
    }
    return this.$heroVideoLarge
  },

  _getActiveHeroVideo() {
    return this.activeHeroVideo || this.$heroVideoLarge
  },

  _activateHeroVideoSource(videoEl) {
    if (!videoEl) return
    var source = videoEl.querySelector('source[data-src]')
    if (!source) return
    source.setAttribute('src', source.getAttribute('data-src'))
    source.removeAttribute('data-src')
    videoEl.muted = true
    videoEl.defaultMuted = true
    videoEl.setAttribute('muted', '')
    videoEl.setAttribute('playsinline', '')
    videoEl.setAttribute('webkit-playsinline', '')
    videoEl.load()
  },

  _heroAnimation() {
    // Show the hero intro immediately. The previous implementation waited for
    // window load + 2500ms, which delayed the H1 and hurt perceived/LCP timing.
    var $splash = $('.heading--splash')
    var $intro = $('.hero__intro')
    if ($splash.length && $intro.length) {
      $splash.hide()
      $intro.show()
    }
  },

  _repairNegativeTabIndexes() {
    $('#sb_instagram a[tabindex="-1"], .footer__social a[tabindex="-1"]').removeAttr('tabindex')
  },

  _ensureMobileNavVisibleForFocus() {
    if (window.matchMedia('(min-width: 960px)').matches) {
      return
    }

    if (!this.$mainNav.hasClass('is-active')) {
      this.$mainNav.addClass('is-active')
      this.$hamburger.addClass('is-active')
      this.$body.addClass('has-nav')
      this.$hamburger.attr('aria-expanded', 'true')
    }
  },

  _annotateBlankLinks() {
    var srSuffix = 'Opens a new tab'

    $('a[target="_blank"], a[target="_new"]').each(function() {
      var $link = $(this)
      var $srOnly = $link.find('.u-sr-only').first()

      if ($srOnly.length) {
        var srText = $srOnly.text().replace(/\s+/g, ' ').trim()

        if (!srText.length) {
          $srOnly.text(srSuffix)
          return
        }

        if (srText.toLowerCase().indexOf(srSuffix.toLowerCase()) === -1) {
          $srOnly.text(srText + ', ' + srSuffix)
        }

        return
      }

      $link.append('<span class="u-sr-only">' + srSuffix + '</span>')
    })
  },

  _hasGoogleMaps() {
    return typeof window.google !== 'undefined' && window.google.maps;
  },

  _handleConsentCategories(e) {
    var categories = e && e.detail && Array.isArray(e.detail.categories) ? e.detail.categories : [];

    if (!$('.js-map').length) {
      return;
    }

    this.mapMarketingConsent = categories.indexOf('marketing') !== -1;
    if (!this.mapMarketingConsent) {
      this._teardownMap();
      return;
    }

    this._waitForGoogleMaps();
  },

  _waitForGoogleMaps() {
    if (!this.mapMarketingConsent || this.mapInitialized || this.mapInitializationPending) {
      return;
    }

    this.mapInitializationPending = true;

    var attempts = 0;
    var maxAttempts = 50;
    this.mapWaitTimer = window.setInterval(function() {
      attempts += 1;

      if (!this.mapMarketingConsent) {
        this._clearMapWaitTimer();
        return;
      }

      if (this._hasGoogleMaps()) {
        this._clearMapWaitTimer();
        this._createMap();
        return;
      }

      if (attempts >= maxAttempts) {
        this._clearMapWaitTimer();
      }
    }.bind(this), 100);
  },

  _clearMapWaitTimer() {
    if (this.mapWaitTimer !== null) {
      window.clearInterval(this.mapWaitTimer);
    }
    this.mapWaitTimer = null;
    this.mapInitializationPending = false;
  },

  _teardownMap() {
    this._clearMapWaitTimer();

    if (this.googleMapMarker) {
      if (this._hasGoogleMaps() && google.maps.event) {
        google.maps.event.clearInstanceListeners(this.googleMapMarker);
      }
      this.googleMapMarker.setMap(null);
    }

    if (this.googleMap && this._hasGoogleMaps() && google.maps.event) {
      google.maps.event.clearInstanceListeners(this.googleMap);
    }

    this.googleMapMarker = null;
    this.googleMap = null;
    this.mapInitialized = false;

    var mapElement = document.querySelector('.js-map');
    if (mapElement) {
      while (mapElement.firstChild) {
        mapElement.removeChild(mapElement.firstChild);
      }
      mapElement.removeAttribute('style');
    }
  },

  _initMap() {
    if (this.mapInitialized) {
      return;
    }

    if (this.mapMarketingConsent && this._hasGoogleMaps()) {
      this._createMap();
      return;
    }

    var mapScript = document.getElementById('google-maps-api');
    if (!mapScript) {
      return;
    }

    var initializeMap = function() {
      if (this.mapMarketingConsent && this._hasGoogleMaps()) {
        this._createMap();
      }
    }.bind(this);

    mapScript.addEventListener('load', initializeMap, { once: true });

    mapScript.addEventListener('error', function() {
      console.warn('Google Maps failed to load.');
    }, { once: true });
  },

  _createMap() {
    if (!this.mapMarketingConsent || this.mapInitialized || !this._hasGoogleMaps()) {
      return;
    }

    if (typeof lat1 === 'undefined' || typeof lng1 === 'undefined') {
      return;
    }

    // Basic options for a simple Google Map
    // For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
    var mapOptions = {
      // How zoomed in you want the map to start at (always required)
      zoom: 15,
      scrollwheel: false,
      navigationControl: false,
      mapTypeControl: false,
      scaleControl: false,
      draggable: false,
      center: new google.maps.LatLng(lat1, lng1),

      // The latitude and longitude to center the map (always required)

      // How you would like to style the map.
      // This is where you would paste any style found on Snazzy Maps.
      styles: [
        {
          "featureType": "administrative",
          "elementType": "all",
          "stylers": [
            {
              "saturation": "-100"
            }
          ]
        }, {
          "featureType": "administrative.province",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        }, {
          "featureType": "landscape",
          "elementType": "all",
          "stylers": [
            {
              "saturation": -100
            }, {
              "lightness": 65
            }, {
              "visibility": "on"
            }
          ]
        }, {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [
            {
              "saturation": -100
            }, {
              "lightness": "50"
            }, {
              "visibility": "simplified"
            }
          ]
        }, {
          "featureType": "road",
          "elementType": "all",
          "stylers": [
            {
              "saturation": "-100"
            }
          ]
        }, {
          "featureType": "road.highway",
          "elementType": "all",
          "stylers": [
            {
              "visibility": "simplified"
            }
          ]
        }, {
          "featureType": "road.arterial",
          "elementType": "all",
          "stylers": [
            {
              "lightness": "30"
            }
          ]
        }, {
          "featureType": "road.local",
          "elementType": "all",
          "stylers": [
            {
              "lightness": "40"
            }
          ]
        }, {
          "featureType": "transit",
          "elementType": "all",
          "stylers": [
            {
              "saturation": -100
            }, {
              "visibility": "simplified"
            }
          ]
        }, {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "hue": "#ffff00"
            }, {
              "lightness": -25
            }, {
              "saturation": -97
            }
          ]
        }, {
          "featureType": "water",
          "elementType": "labels",
          "stylers": [
            {
              "lightness": -25
            }, {
              "saturation": -100
            }
          ]
        }
      ]

    };

    var pin = {
      url: '/wp-content/themes/_revel/library/img/map-pin.png',
      size: new google.maps.Size(60, 76),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(15, 38),
      scaledSize: new google.maps.Size(60, 76)
    };

    // Get the HTML DOM element that will contain your map
    // We are using a div with id='map' seen below in the <body>
    var mapElement = document.querySelector('.js-map');
    if (!mapElement) {
      return;
    }

    this.googleMap = new google.maps.Map(mapElement, mapOptions);

    this.googleMapMarker = new google.maps.Marker({
      //position: new google.maps.LatLng(30.2850233, -97.7136788),
      position: new google.maps.LatLng(lat1, lng1),
      map: this.googleMap,
      title: 'Revel',
      icon: pin
    });

    this.mapInitialized = true;
  },

  _playHeroVideo(e) {
    if (e && e.preventDefault) {
      e.preventDefault()
    }

    var videoEl = this._getHeroVideoForPlayback()
    if (!videoEl) return

    var heroVideo = $('.hero--video')
    var useMobileVideo = videoEl === this.$heroVideoSmall

    if (this.$heroVideoLarge && videoEl !== this.$heroVideoLarge) {
      this.$heroVideoLarge.pause()
    }
    if (this.$heroVideoSmall && videoEl !== this.$heroVideoSmall) {
      this.$heroVideoSmall.pause()
    }

    this._activateHeroVideoSource(videoEl)
    this.activeHeroVideo = videoEl

    heroVideo.addClass('is--large-video').removeClass('is--small-video')
    heroVideo.toggleClass('is--mobile-video', useMobileVideo)

    var playPromise = videoEl.play()

    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.then(function() {
        this.$heroControls.removeClass('is--paused').addClass('is--playing')
        this._syncHeroVideoControls()
      }.bind(this)).catch(function() {
        this.$heroControls.removeClass('is--playing').addClass('is--paused')
        this._syncHeroVideoControls()
      }.bind(this))
      return
    }

    this.$heroControls.removeClass('is--paused').addClass('is--playing')
    this._syncHeroVideoControls()
  },

  _muteHeroVideo(e) {
    var videoEl = this._getActiveHeroVideo()
    if (!videoEl) return

    if (videoEl.muted) {
      videoEl.muted = false
      this.$heroControls.removeClass('is--muted').addClass('is--unmuted')
    } else {
      videoEl.muted = true
      this.$heroControls.removeClass('is--unmuted').addClass('is--muted')
    }
    this._syncHeroVideoControls()
  },

  _pauseHeroVideo(e) {
    var videoEl = this._getActiveHeroVideo()
    if (!videoEl) return

    if (videoEl.paused) {
      var playPromise = videoEl.play()

      if (playPromise && typeof playPromise.then === 'function') {
        playPromise.then(function() {
          this.$heroControls.removeClass('is--paused').addClass('is--playing')
          this._syncHeroVideoControls()
        }.bind(this)).catch(function() {
          this.$heroControls.removeClass('is--playing').addClass('is--paused')
          this._syncHeroVideoControls()
        }.bind(this))
        return
      }

      this.$heroControls.removeClass('is--paused').addClass('is--playing')
    } else {
      videoEl.pause()
      this.$heroControls.removeClass('is--playing').addClass('is--paused')
    }
    this._syncHeroVideoControls()
  },

  _fullscreenHeroVideo(e) {
    if ($heroVideoLarge.requestFullscreen) {
      $heroVideoLarge.requestFullscreen();
    } else if ($heroVideoLarge.mozRequestFullScreen) {
      $heroVideoLarge.mozRequestFullScreen(); // Firefox
    } else if ($heroVideoLarge.webkitRequestFullscreen) {
      $heroVideoLarge.webkitRequestFullscreen(); // Chrome and Safari
    }
  },

  _exitFullscreenHeroVideo(e) {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
  },

  _resetHeroVideo(e) {
    var heroVideo = $('.hero--video')

    if (this.$heroVideoLarge) {
      this.$heroVideoLarge.pause()
      this.$heroVideoLarge.currentTime = 0
    }
    if (this.$heroVideoSmall) {
      this.$heroVideoSmall.pause()
      this.$heroVideoSmall.currentTime = 0
    }

    this.activeHeroVideo = null
    heroVideo.removeClass('is--large-video is--mobile-video')
    heroVideo.addClass('is--small-video')
    this.$heroControls.removeClass('is--playing').addClass('is--paused')
    this._syncHeroVideoControls()
  },

  _syncHeroVideoControls() {
    var videoEl = this._getActiveHeroVideo()
    if (!videoEl) return

    var isMuted = videoEl.muted
    var isPaused = videoEl.paused

    if (this.$heroAudioControl.length) {
      this.$heroAudioControl
        .attr('aria-label', isMuted ? 'unmute video' : 'mute video')
        .attr('aria-pressed', isMuted ? 'true' : 'false')
    }

    if (this.$heroPlaybackControl.length) {
      this.$heroPlaybackControl
        .attr('aria-label', isPaused ? 'play video' : 'pause video')
        .attr('aria-pressed', isPaused ? 'true' : 'false')
    }
  },

  _initInstagram() {
    var instaContainers = $('.js-instagram');
    var hashtag = 'revelweb';
    var taggedPhotos = [];

    function populateInstagram(data, overlay) {

      var caption = data.caption.text;
      var html = [
        '<a href="' + data.link + '" target="_blank">',
        '<div class="grid-item__solid grid-item__solid--instagram lazyload" data-bg="' + data.images.standard_resolution.url + '">',
        '<span class="grid-item__category u-text-lowercase">Instagram</span>',
        '<div class="grid-item__title">',
        '<div class="grid-item__icon"></div>',
        '<h3 class="heading--lg u-text-lowercase">' + caption.substr(0, 100) + '...</h3>',
        '</div>',
        '<div class="grid-item__overlay grid-item__overlay--' + overlay + '"></div>',
        '</div>',
        '</a>'
      ].join('');

      return html;
    }

    var feed = new Instafeed({
      get: 'user', accessToken: '1059947729.1677ed0.4fb30dbc741545d0b66f4e3374c45493', sortBy: 'most-recent', userId: '1059947729', // https://www.instagram.com/nicholsbooth/
      limit: '20',
      mock: true,
      success: function(instagram) {

        if (hashtag.length) {

          // "search" for tagged photos first
          for (var i = 0; i < instagram.data.length; i++) {
            if (instagram.data[i].tags.indexOf(hashtag) >= 0) {
              taggedPhotos.push(instagram.data[i]);
            }
          }

          if (taggedPhotos.length) {
            // populate the containers
            instaContainers.each(function(index, el) {
              $(el).html(populateInstagram(taggedPhotos[index], $(el).data('overlay')));
            });
          }

        } else {

          // populate the containers
          instaContainers.each(function(index, el) {
            $(el).html(populateInstagram(instagram.data[index], $(el).data('overlay')));
          });
        }

      }
    });
    feed.run();

  }, // _loadInstagram

  _scrollToTop(e) {
    this.$body.animate({
      scrollTop: 0
    }, 500);
  },

  _scrollToSection(e) {
    var section = $(e.currentTarget).attr('href');
    var el = $(section);
    if (el.length) {
      this.$body.animate({
        scrollTop: el.offset().top - 100
      }, 500);
    }
  },

  _initPopups() {
    $('.js-popup').magnificPopup({type: 'inline', midClick: true, removalDelay: 100, mainClass: 'popup--animate'});
  },

  _initHeadroom() {
    var theHeader = document.querySelector('.js-header');
    var headroom = new Headroom(theHeader);
    headroom.init();
  },

  _showMobileNav(e) {
    e.preventDefault();
    this.$mainNav.toggleClass('is-active');
    this.$hamburger.toggleClass('is-active');
    this.$body.toggleClass('has-nav');

    var isOpen = this.$mainNav.hasClass('is-active');
    this.$hamburger.attr('aria-expanded', isOpen ? 'true' : 'false');
  },

  _showContactMapAddress(e){
    if (!this.mapMarketingConsent) {
      return;
    }

    e.preventDefault();
    var mapUrl = e.currentTarget.attributes.href.value;
    var coordinates = this._extractCoordinates(mapUrl);
    console.log(coordinates + 'sssss')
    if (coordinates) {
      var latitude = coordinates.lat;
      var longitude = coordinates.lng;
      console.log(latitude + ' - lat ---- long - ' + longitude)

      this._showMap(latitude, longitude);
    } else {
      console.error('Invalid or missing coordinates in the Google Maps URL.');
    }
  },

  _extractCoordinates(mapUrl) {
    // Regular expression to extract latitude and longitude from the Google Maps URL
    const regex = /@([-+]?\d*\.?\d+),([-+]?\d*\.?\d+)/;
    const match = mapUrl.match(regex);
    
    if (match && match.length === 3) {
      const latitude = parseFloat(match[1]);
      const longitude = parseFloat(match[2]);

      // Check if the extracted values are valid numbers
      if (!isNaN(latitude) && !isNaN(longitude)) {
        // Round the values to a reasonable precision, e.g., 6 decimal places
        const roundedLatitude = parseFloat(latitude.toFixed(12));
        const roundedLongitude = parseFloat(longitude.toFixed(12));

        return { lat: roundedLatitude, lng: roundedLongitude };
      }
    }

    return null;
  },

  _showMap(latitude, longitude) {
    if (!this.mapMarketingConsent || !this._hasGoogleMaps()) {
      console.warn('Google Maps is unavailable.');
      return;
    }

    // Assuming that 'js-map' is the correct class for your map container
    var mapContainer = document.querySelector('.js-map');

    if (mapContainer) {
      // Map options
      var mapOptions = {
        zoom: 15,
        scrollwheel: false,
        navigationControl: false,
        mapTypeControl: false,
        scaleControl: false,
        draggable: false,
        center: new google.maps.LatLng(latitude, longitude),
        styles: [
          {
            "featureType": "administrative",
            "elementType": "all",
            "stylers": [
              {
                "saturation": "-100"
              }
            ]
          }, {
            "featureType": "administrative.province",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          }, {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
              {
                "saturation": -100
              }, {
                "lightness": 65
              }, {
                "visibility": "on"
              }
            ]
          }, {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
              {
                "saturation": -100
              }, {
                "lightness": "50"
              }, {
                "visibility": "simplified"
              }
            ]
          }, {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
              {
                "saturation": "-100"
              }
            ]
          }, {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "simplified"
              }
            ]
          }, {
            "featureType": "road.arterial",
            "elementType": "all",
            "stylers": [
              {
                "lightness": "30"
              }
            ]
          }, {
            "featureType": "road.local",
            "elementType": "all",
            "stylers": [
              {
                "lightness": "40"
              }
            ]
          }, {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
              {
                "saturation": -100
              }, {
                "visibility": "simplified"
              }
            ]
          }, {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
              {
                "hue": "#ffff00"
              }, {
                "lightness": -25
              }, {
                "saturation": -97
              }
            ]
          }, {
            "featureType": "water",
            "elementType": "labels",
            "stylers": [
              {
                "lightness": -25
              }, {
                "saturation": -100
              }
            ]
          }
        ]
      };

      if (this.googleMap && this.googleMapMarker) {
        var position = new google.maps.LatLng(latitude, longitude);
        this.googleMap.setCenter(position);
        this.googleMapMarker.setPosition(position);
        return;
      }

      // Create a new map instance
      this.googleMap = new google.maps.Map(mapContainer, mapOptions);

      // Marker options
      var pin = {
        url: '/wp-content/themes/_revel/library/img/map-pin.png',
        size: new google.maps.Size(60, 76),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(15, 38),
        scaledSize: new google.maps.Size(60, 76)
      };

      // Add a marker to the map
      this.googleMapMarker = new google.maps.Marker({
        position: new google.maps.LatLng(latitude, longitude),
        map: this.googleMap,
        title: 'Revel',
        icon: pin
      });
      this.mapInitialized = true;
    } else {
      console.error('Map container not found.');
    }
  }

}; // Revel

Revel.init();
